var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export function pxToRem(value) {
    return "".concat(value / 16, "rem");
}
export var fontFamily = '"Open Sans", "Helvetica", "Arial", sans-serif';
export var fontFamilySerif = '"Noto Serif", serif';
export var fontSizes = {
    fontSizeXSmall: pxToRem(10),
    fontSizeSmall: pxToRem(12),
    fontSizeDefault: pxToRem(14),
    fontSizeMedium: pxToRem(16),
    fontSizeLarge: pxToRem(18),
    fontSizeXLarge: pxToRem(24),
    fontSizeXXLarge: pxToRem(30),
};
export var fontWeights = {
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightSemiBold: 600,
    fontWeightBold: 700,
};
export var typeStyles = {
    display1: {
        fontFamily: fontFamilySerif,
        fontSize: fontSizes.fontSizeXXLarge,
        fontWeight: fontWeights.fontWeightRegular,
        lineHeight: 1.5,
    },
    display2: {
        fontSize: fontSizes.fontSizeXXLarge,
        fontWeight: fontWeights.fontWeightLight,
        lineHeight: 1.5,
    },
    headingXLarge: {
        fontSize: fontSizes.fontSizeXLarge,
        fontWeight: fontWeights.fontWeightRegular,
        lineHeight: 1.5,
    },
    headingLarge: {
        fontSize: fontSizes.fontSizeLarge,
        fontWeight: fontWeights.fontWeightSemiBold,
        lineHeight: 1.5,
    },
    headingMedium: {
        fontSize: fontSizes.fontSizeMedium,
        fontWeight: fontWeights.fontWeightSemiBold,
        lineHeight: 1.5,
    },
    headingDefault: {
        fontSize: fontSizes.fontSizeDefault,
        fontWeight: fontWeights.fontWeightSemiBold,
        lineHeight: 1.5,
    },
    headingSmall: {
        fontSize: fontSizes.fontSizeSmall,
        fontWeight: fontWeights.fontWeightSemiBold,
        lineHeight: 1.5,
    },
    headingXSmall: {
        fontSize: fontSizes.fontSizeXSmall,
        fontWeight: fontWeights.fontWeightBold,
        lineHeight: 1.5,
    },
    bodyDefault: {
        fontFamily: fontFamily,
        fontSize: fontSizes.fontSizeDefault,
        fontWeight: fontWeights.fontWeightRegular,
        lineHeight: 1.5,
    },
    bodySmall: {
        fontFamily: fontFamily,
        fontSize: fontSizes.fontSizeSmall,
        fontWeight: fontWeights.fontWeightRegular,
        lineHeight: 1.5,
    },
    subtitle1: {
        fontSize: fontSizes.fontSizeMedium,
    },
    subtitle2: {
        fontSize: fontSizes.fontSizeDefault,
        fontWeight: fontWeights.fontWeightSemiBold,
    },
    button: {
        fontSize: fontSizes.fontSizeDefault,
        fontWeight: fontWeights.fontWeightRegular,
    },
    caption: {
        fontSize: fontSizes.fontSizeSmall,
    },
    overline: {
        fontSize: fontSizes.fontSizeSmall,
    },
};
export var typography = __assign(__assign(__assign({ pxToRem: pxToRem, fontFamily: fontFamily, fontFamilySerif: fontFamilySerif }, fontSizes), fontWeights), typeStyles);
export default typography;
//# sourceMappingURL=typography.js.map